/**
 *
 * Dropdown (simple, based on react-dropdown)
 *
 */
/* eslint-disable */
/* eslint-disable prefer-template */
import ReactDropdown from './ReactDropdown';

import 'react-dropdown/style.css';
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import './style.scss';
import { LAYOUT_BREAK_SMALL } from '../../containers/App/constants';
import { VBox } from '../Box';
import { COLOR_PRIMARY_1, COLOR_GREY_TINT } from '../../vars';
import { Times, Tiles } from '../Icon';
import _ from 'lodash';
import { normalizeSearchString } from '../../utils/normalizeSearchString';
import { BaseComponent } from '../BaseComponent';

export class Dropdown extends BaseComponent {
  constructor(props) {
    super(props, {
      filter: '',
    });
  }

  get filteredOptions() {
    if (!this.props.filter || !this.state.filter) return this.props.options;

    return _.filter(
      this.props.options,
      o => normalizeSearchString(o.label).indexOf(normalizeSearchString(this.state.filter)) > -1,
    );
  }

  render() {
    let props = this.props;
    if (props.options.length && props.options[0].name) throw 'used name, should use label';

    // if (window.innerWidth <= LAYOUT_BREAK_SMALL) return <DropdownListView {...props} />;
    //todo: on small screen, render an alternative dropdown
    return (
      <ReactDropdown
        filter
        disabled={!!this.props.disabled}
        options={this.filteredOptions}
        onChange={this.props.onChange?.bind(this)}
        value={props.value}
        placeholder={props.placeholder}
        className={props.className}
      />
    );
  }
}

Dropdown.propTypes = {
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,

  //simple {label,value}
  value: PropTypes.any,
  placeholder: PropTypes.any,
};

const Container = styled.div``;
const ListContainer = styled.div`
  position: fixed;
  overflow-y: scroll;

  background-color: rgba(0, 0, 0, 0.85);
  padding: 12px;
  z-index: 9999;

  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;

  display: flex;
  flex-direction: column;
`;

const ListOption = styled.div`
    padding: 12px 0;
    background-color:white;
    border-bottom:1px solid #ddd;

    &.selected {
        background-color: ${COLOR_GREY_TINT};
        color:black;
    }
`;

const CloseContainer = styled.div`
  text-align: right;
  width: 100%;
  color: white;
  position: sticky;
  top: 0px;

  > div {
    display: inline-block;
    background-color: rgba(0, 0, 0, 0.75);
    padding: 12px;
  }
`;

class DropdownListView extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  get listContainer() {
    if (!this._el) {
      this._el = document.createElement('div');
      this._el.style.display = 'contents';
    }

    document.body.appendChild(this._el);

    return this._el;
  }

  componentWillUnmount() {
    try {
      document.body.removeChild(this.el);
    } catch (e) {}
  }

  toggle() {
    if (this.state.open) this.close();
    else this.open();
  }
  open() {
    this.setState({ open: true });
  }

  close() {
    this.setState({ open: false });
  }

  getSelected() {
    try {
      if (this.props.value.value) return this.props.value;
    } catch (e) {}
    return _.find(this.props.options, o => o.value == this.props.value);
    return (
      _.find(this.props.options, o => o.value == this.props.value) ||
      _.find(this.props.options, o => o.label == this.props.value) ||
      {}
    );
  }

  render() {
    let selected = this.props.value; // this.getSelected();

    let label = '';
    //so many scenarios of setting value ...
    if (!selected) {
      label = this.props.placeholder;
    } else if (_.isString(selected)) {
      let selectedOption = _.find(this.props.options, o => o.value == selected);
      if (selectedOption) label = selectedOption.label;
      else label = selected;
    } else if ('value' in selected) {
      if ('label' in selected) label = selected.label;
    } else {
      label = selected || this.props.placeholder || <>&nbsp;</>;
    }
    return (
      <Container className="Dropdown-root" onClick={this.toggle.bind(this)}>
        <div className="Dropdown-control">
          <div className="Dropdown-placeholder">{label}...</div>

          <div className="Dropdown-arrow-wrapper">
            <div className="Dropdown-arrow"></div>
          </div>
        </div>
        {this.state.open ? this.renderList() : ''}
      </Container>
    );
  }

  renderList() {
    return ReactDOM.createPortal(
      <ListContainer>
        <CloseContainer>
          <div onClick={this.close.bind(this)}>
            <Times />
          </div>
        </CloseContainer>
        <div className="options">{this.props.options.map(this.renderOption.bind(this))}</div>
      </ListContainer>,
      this.listContainer,
    );

    return (
      <ListContainer>
        <CloseContainer>
          <div onClick={this.close.bind(this)}>
            <Times />
          </div>
        </CloseContainer>
        <div className="options">{this.props.options.map(this.renderOption.bind(this))}</div>
      </ListContainer>
    );
  }

  onChange(option) {
    let result = { ...option };

    if (!('value' in result)) result.value = option.label;

    this.props.onChange(result);
  }

  renderOption(option, index) {
    let selected = this.getSelected();
    let selectedValue = selected ? selected.value : null;

    return (
      <ListOption
        key={`option-${index}`}
        className={`${option.value == selectedValue ? 'selected' : 'not-selected'}`}
        onClick={() => {
          this.onChange(option);
          this.close();
        }}
      >
        {option.label}
      </ListOption>
    );
  }
}
